import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import MuiButton from "@material-ui/core/Button";
import TabLayout from "components/Layouts/TabLayout";
import GameLayout from "components/Layouts/GameLayout";
import MultipleLetters from "components/Letter/MultipleLetters";
import MessageModal from "components/Modal";
import { IGameProps, ILimitedSelectionGroupOrders } from "./IGame";

import axios from "axios";
import uuid from "uuid";

const LetterGame = (props: IGameProps) => {
  const [myAnswer, setMyAnswer] = useState("");
  const [numberOfAttempts, setNumberOfAttempts] = useState(0);
  const [endTime, setEndTime] = useState(false);

  const [resetFunction, setResetFunction] = useState<() => void>(() => () => console.debug("default reset function"));
  // const [limitedLetters, setLimitedLetters] = useState(Array<ILimitedSelectionGroupOrders>);

  useEffect(() => {
    if (props.progress) {
      setNumberOfAttempts(props.progress.number_of_attempts);
    }
  }, [props.progress?.number_of_attempts]);

  // useEffect(() => {
  //   if (props.progress) {
  //     setNumberOfAttempts(props.progress.number_of_attempts);
  //   }
  // }, [props.progress?.]);

  // useEffect(() => {
  //   if (props.defaultPuzzleSettings) {
  //   setLimitedLetters(props.defaultPuzzleSettings.limited_selection_group_orders);
  // }
  // }, [props.defaultPuzzleSettings?.limited_selection_group_orders]);

  const handleAnswerChange = (answer: string) => {
    console.debug("Handle Answer Change in Letter Game called - ", answer);
    setMyAnswer(answer);
  };

  const handleCheckAnswer = () => {
    console.debug("Checking answer: ", myAnswer, " for id: ", props.id);
    props.checkAnswer.call(undefined, props.id, myAnswer);
  };

  const addResetButton = () => {
    // console.info("Game Type: ", props.gameType);
    // console.debug("GridRef: ", gridRef, " GridRef.Current: ", gridRef.current);
    // console.debug("Creating Reset Button");
    return (
      <Button
        color="primary"
        className="mr-2"
        onClick={() => {
          if(resetFunction) {
            resetFunction();
          }
        }}
      >
        Reset
      </Button>
    );
  };

// The key to this is that you must return a function that returns a function
// () => () => function()
  const shareResetFunction = (functionToShare: () => void) => {
    setResetFunction(() => () => functionToShare());
  }

  return (
    <div className="mx-auto">
      <div className="game justify-content-center">
        <TabLayout
          instructions={props.instructions}
          imageUrl={props.imageUrl}
          video={props.video}
          audio={props.audio}
        >
          <GameLayout
            questionImageUrl={props.questionImageUrl}
            game={
              <MultipleLetters
                numberOfLetters={props.answer_length}
                onChange={handleAnswerChange}
                limitedLetters={
                  props.defaultPuzzleSettings &&
                  props.defaultPuzzleSettings.limited_selection_group_orders
                    ? props.defaultPuzzleSettings.limited_selection_group_orders
                    : undefined
                }
              />
            }
            button={
              <MuiButton
                variant="contained"
                color="primary"
                onClick={handleCheckAnswer}
                className="mr-1"
              >
                Submit
              </MuiButton>
            }
            id={props.id}
            hasHint={props.has_hint}
            requestHint={props.requestHint}
            numberOfAttempts={numberOfAttempts}
            settings={props.defaultPuzzleSettings}
            progress={props.progress}
          />
        </TabLayout>
      </div>
      <div className="d-flex flex-row grid-game justify-content-center"></div>
    </div>
  );
};
export default LetterGame;
